import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../services/api';
import RequirementsList from '../../components/admin/RequirementsList';
import TheoryQuestionsList from '../../components/admin/TheoryQuestionsList';
import PrecursorsList from '../../components/admin/PrecursorsList';
import WeightTablesList from '../../components/admin/WeightTablesList';
import { InlineAlert, LoadingState, PageHeader, Tabs } from '../../components/admin/ui';

const BeltContentManagement = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [belt, setBelt] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    const fetchBelt = async () => {
      try {
        const response = await api.get(`/admin/belts/${id}`);
        setBelt(response.data.data);
      } catch (error) {
        console.error('Error fetching belt:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchBelt();
  }, [id]);

  if (loading) return <LoadingState />;

  if (!belt) {
    return (
      <div className="admin-page">
        <InlineAlert tone="error">Cinturón no encontrado</InlineAlert>
      </div>
    );
  }

  const tabs = [
    { id: 'req', label: 'Requisitos' },
    { id: 'theory', label: 'Teoría' },
    { id: 'precursors', label: 'Precursores' },
    { id: 'weights', label: 'Pesos' },
  ];

  return (
    <div className="admin-page">
      <PageHeader title={`Contenido: ${belt.name}`} onBack={() => navigate('/admin/belts')} />
      <div className="mb-6 flex items-center gap-3">
        <span
          className="h-12 w-12 rounded-full border-2 border-line"
          style={{ backgroundColor: belt.color_code || '#000' }}
        />
        <span className="rounded-full border border-primary/30 px-2.5 py-1 text-xs font-semibold text-primary">
          Nivel {belt.hierarchy_order}
        </span>
      </div>

      <Tabs tabs={tabs} value={tabValue} onChange={setTabValue} />
      <div className="pt-6">
        {tabValue === 0 && <RequirementsList beltId={parseInt(id, 10)} />}
        {tabValue === 1 && <TheoryQuestionsList beltId={parseInt(id, 10)} />}
        {tabValue === 2 && <PrecursorsList beltId={parseInt(id, 10)} />}
        {tabValue === 3 && <WeightTablesList beltId={parseInt(id, 10)} />}
      </div>
    </div>
  );
};

export default BeltContentManagement;
